import { api } from "assets/scripts/utilities/api-clients";

const prepareInvoice = (invoice) => {
  delete invoice.bill;

  delete invoice.po;

  const {
    bill_id,
    buyer,
    created_by,
    po_id,
    timelines,
    deal_setting = {},
    ...rest
  } = invoice;

  const preparedInvoice = {
    ...rest,
    bill_id: bill_id?._id || bill_id,
    buyer: buyer?._id || buyer,
    created_by: created_by?._id || created_by,
    po_id: po_id?._id || po_id,
    deal_setting: {
      ...deal_setting,
      timelines: timelines || [],
    },
  };

  return preparedInvoice;
};

export const autoGenerate = async ({ invoice, isGstExempted }) => {
  try {
    const {
      _id,
      dispatch_from_address,
      shipping_address,
      billing_address,
      branch_state_code,
      transaction_series_name,
      fssai,
      autoptions,
    } = invoice;

    let payload = { _id, gst_exempted: unref(isGstExempted) };

    if (unref(isGstExempted)) {
      payload.invoice = {
        _id,
      };
    } else {
      payload.invoice = {
        _id,
        dispatch_from_address,
        shipping_address,
        billing_address,
        branch_state_code,
        transaction_series_name,
        fssai,
        autoptions: autoptions.map((option) => Number.parseInt(option)),
      };
    }

    const response = await api.put("/account/invoices/auto-generate", payload);

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const cancel = async (params) => {
  const { invoice, removeFiles, path = "kam" } = params;

  const endpoints = {
    kam: {
      invoice: {
        cancel: "/kam/invoices/cancel",
      },
    },
    account: {
      invoice: {
        cancel: "/account/invoices/cancel",
      },
    },
  };

  const response = await api.put(endpoints[path].invoice.cancel, {
    _id: invoice._id,
    reason: invoice.reason,
    isFilesToBeRemoved: removeFiles,
  });

  return response;
};

export const complete = async (invoice) => {
  const response = await api.put(`/account/invoices/complete`, {
    _id: invoice._id,
  });

  return response;
};

export const accept = async (invoice) => {
  const response = await api.put("/account/invoices/accept/", invoice);

  return response;
};

export const get = async (id) => {
  const response = await api.get(`/sales/invoice/${id}`);

  return response;
};

export const index = async (options = {}) => {
  const { source = "kam", ...rest } = options;

  const url = {
    sales: "/sales/invoices",
    kam: "/kam/invoices",
  };

  const response = await api.get(url[source], rest);

  return response;
};

export const post = async (invoice) => {
  const response = await api.post("/kam/invoices", prepareInvoice(invoice));

  return response;
};

export const put = async (
  invoice,
  options = {
    params: {
      showMessage: false,
    },
  },
) => {
  const response = await api.put(
    "/account/invoices",
    prepareInvoice(invoice),
    options,
  );

  return response;
};

export const checkNumber = async (number) => {
  const response = await api.put("/account/invoices/number", number);

  return response;
};

export const postValidateOversellingInvoice = async (invoice) => {
  const response = await api.post(
    "/kam/invoices/validate-overselling",
    prepareInvoice(invoice),
  );

  return response;
};

export const postSendInvoiceForApproval = async (invoice) => {
  const response = await api.post(
    "/kam/invoices/request-approval",
    prepareInvoice(invoice),
  );

  return response;
};

export const putApproversInvoiceStatus = async (
  invoice,
  options = {
    params: {
      showMessage: false,
    },
  },
) => {
  const response = await api.put(
    "/kam/invoices/mark-approver-status",
    invoice,
    options,
  );

  return response;
};
